import styled from "styled-components";
import { media } from "../../theme/theme";
import { Body } from "../Typography";

export const TextWrapper = styled.div<{ homepageVariant: boolean }>`
    display: ${({ homepageVariant }) => homepageVariant ? undefined : "flex"};
    width: 100%;
    margin: 0 auto 25px;
    padding: 0 15px;
    align-items: center;
    max-width: ${({ homepageVariant }) => homepageVariant ? "930px" : undefined};
    text-align: ${({ homepageVariant }) => homepageVariant ? "center" : undefined};
    vertical-align: middle;
    justify-content: center;
    flex-wrap: wrap;

    ${media.desktop} {
        flex-wrap: nowrap;
    }

    ${Body} {
        color: ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};
        text-align: center;

        ${media.desktop} {
            font-size: 20px;
            line-height: 32px;
        }

        ${media.desktop} {
           text-align: left;
        }
    }

    > div {
        &:nth-child(1) {
            margin-bottom: 5px;

            ${media.desktop} {
                margin-right: 16px;
                margin-bottom: 0;
            }

            img{
                width: 46px;
                height: auto;
            }
        }

        &:nth-child(2) {
            width: 100%;
            margin-bottom: ${({ homepageVariant }) => homepageVariant ? "40px" : undefined};

            ${media.desktop} {
                margin-bottom: ${({ homepageVariant }) => homepageVariant ? "80px" : undefined};
                width: auto;
            }
        }
    }
`;